import React, { useState } from "react";
import "./CSS/ArtSection.css";

import defaultImg from "./IMAGES/Vector (2).png";
import img1 from "./IMAGES/Vector (3).png";
import img2 from "./IMAGES/Vector (4).png";
import img3 from "./IMAGES/Vector (5).png";
import img4 from "./IMAGES/Vector (6).png";
import img5 from "./IMAGES/Vector (7).png";


const data = [
  {
    title: "Thoughtful Fabric Selection",
    desc: "Every beautiful outfit begins with the right fabric. At SaPra, we carefully select high-quality materials that offer comfort. From soft silks and breathable cottons to elegant woven fabrics, every material is chosen to ensure that the final piece feels as luxurious as it looks.",
    img: img1,
  },
  {
    title: "Traditional Craftsmanship",
    desc: "Our creations are brought to life by skilled artisans who carry forward generations of traditional techniques. Using time-honored weaving and stitching methods inspired by regions like Rajasthan and Chanderi, they transform simple threads into stunning garments filled with heritage and artistry.",
    img: img2,
  },
  {
    title: "Designing with Detail",
    desc: "Once the fabric is ready, our designs begin to take shape. From delicate saree borders and elegant kurti patterns to intricate lehenga detailing and stylish blouse designs, every element is thoughtfully crafted to reflect beauty, balance, and timeless fashion.",
    img: img3,
  },
  {
    title: "Careful Hand Finishing",
    desc: "Every piece then goes through careful hand finishing to perfect the look and feel. Skilled hands refine the stitching, enhance the fall of the fabric, and ensure every garment is comfortable, elegant, and ready to be worn for special moments.",
    img: img4,
  },
  {
    title: "Quality You Can Trust",
    desc: "Before reaching you, each SaPra creation undergoes a thorough quality check. We ensure that every saree, kurti set, dress, blouse, and lehenga meets our standards of craftsmanship, comfort, and elegance—so you receive a piece that truly feels special.",
    img: img5,
  },
];

const ArtSection = () => {
  const [active, setActive] = useState(null);

  return (
    <section className="art-section">
      <div className="art-header">
        <h1>The Art Behind SaPra Creations</h1>
        <p>
          Every SaPra creation goes through a thoughtful journey where
          traditional craftsmanship meets modern elegance.
        </p>
      </div>

      <div className="art-content">
        
        {/* LEFT */}
        <div className="art-left">
          <h2>From Thread to Timeless Elegance..!</h2>

          <div className="art-list">
            {data.map((item, i) => (
              <div
                key={i}
                className={`art-item ${active === i ? "active" : ""}`}
onClick={() => setActive(active === i ? null : i)}              >
                <h3>{item.title} <span className="arrow">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="20px"
      viewBox="0 -960 960 960"
      width="20px"
      fill="currentColor"
    >
      <path d="M480-360 280-560h400L480-360Z" />
    </svg>
  </span></h3>

                {active === i && (
                  <p className="desc">{item.desc}</p>
                )}
              </div>
            ))}
          </div>
        </div>

      <div className="art-right">
  <img
    src={active !== null ? data[active].img : defaultImg}
    alt=""
  />
</div>
      </div>
    </section>
  );
};

export default ArtSection;